import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { primeraEntrevista } from "@/data/content";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";

export default function PrimeraEntrevista() {
  return (
    <div data-testid="primera-entrevista-page">
      <PageHeader
        overline="Primera entrevista"
        titleLines={["Antes de", "comenzar"]}
        intro="Un primer encuentro para conocernos y comprender juntos qué te trae a consultar."
      />

      <section className="max-w-[1000px] mx-auto px-5 md:px-10 pb-16 md:pb-24">
        <Reveal>
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {primeraEntrevista.faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-black/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-2xl md:text-3xl tracking-tight py-8 hover:no-underline hover:text-[#9C5A4B] [&>svg]:h-6 [&>svg]:w-6">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="pb-8">
                  <p className="text-lg leading-relaxed text-[#1a1a1a]/80 font-light max-w-2xl">
                    {faq.a}
                  </p>
                  {faq.modalities && (
                    <div className="flex flex-wrap gap-3 mt-6">
                      {faq.modalities.map((m) => (
                        <span
                          key={m}
                          className="inline-flex items-center gap-2 border border-[#9C5A4B]/40 rounded-full px-5 py-2 text-sm text-[#9C5A4B]"
                        >
                          <Check size={15} /> {m}
                        </span>
                      ))}
                    </div>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <div className="bg-[#2A2C29] text-[#f9f8f6] p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <p className="font-display text-3xl md:text-4xl leading-tight max-w-xl">
              Cuando estés lista o listo, podemos comenzar.
            </p>
            <Link
              to="/agenda"
              data-testid="primera-entrevista-cta"
              className="group inline-flex items-center gap-3 rounded-full bg-[#9C5A4B] text-[#f9f8f6] px-7 py-4 text-sm tracking-wide hover:bg-[#8A4A3C] transition-colors duration-300 whitespace-nowrap"
            >
              Agendar una primera entrevista
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
